import { Module } from "vuex";
import { actions, mutations } from ".";
import { RootState } from "..";
import { PAGINATION_FIRST_PAGE } from "../../constants";
import { PaginationMeta } from "./../../models/pagination.model";
import { Timeline } from "./../../models/timeline.model";

export interface TimelineState {
  timeline?: Timeline;
  paginationMeta?: PaginationMeta;
}

const state: TimelineState = {
  timeline: undefined,
  paginationMeta: {
    per_page: 0,
    total: 0,
    current_page: PAGINATION_FIRST_PAGE,
    from: 0,
    to: 0,
    last_page: 0,
    path: ""
  }
};

export const namespaceTimeline = "timeline";

export const timelineModule: Module<TimelineState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations
};

export * from "./timeline.actions";
export * from "./timeline.mutations";
